export class CasoPreocupante {

  public Descripcion: string;

}
